import { forwardRef, useContext, type ComponentRef } from "react";

import { Typography } from "../../atoms/typography";
import { DialogDescriptionPrimitive } from "../../primitives";
import { DialogHeaderAlignContext } from "./lib";
import type { DialogDescriptionProps } from "./types";

/**
 * Dialog.Description
 *
 * Wired to `aria-describedby` on the dialog content. Renders a Typography
 * `body-sm` in the intermediate (muted) foreground color. Centred in a
 * centred Header.
 */
export const DialogDescription = forwardRef<
  ComponentRef<typeof DialogDescriptionPrimitive>,
  DialogDescriptionProps
>(({ children, className }, ref) => {
  const align = useContext(DialogHeaderAlignContext);
  return (
    <DialogDescriptionPrimitive ref={ref} asChild>
      <Typography
        variant="body-sm"
        color="neutral-foreground-intermediate"
        align={align === "center" ? "center" : undefined}
        className={className}
      >
        {children}
      </Typography>
    </DialogDescriptionPrimitive>
  );
});

DialogDescription.displayName = "Dialog.Description";
